'use client'

// Next Imports
import Link from 'next/link'

// MUI Imports
import useMediaQuery from '@mui/material/useMediaQuery'
import { styled, useTheme } from '@mui/material/styles'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

// Third-party Imports
import classnames from 'classnames'

// Type Imports
import type { SystemMode } from '@core/types'

// Component Imports
import { brandify } from '@components/Brand'

// Hook Imports
import { useImageVariant } from '@core/hooks/useImageVariant'
import { useTranslation } from '@/i18n'


// La 404 vestita TVirt (Luca 2026-07-31): via il pupazzo e l'inglese fisso di
// Vuexy — resta la maschera di sfondo theme-aware, arrivano i testi i18n (la
// rotta [...not-found] è dentro Providers: cookie lingua e SSR giusti) e il
// rientro punta alla Home vera.
const MaskImg = styled('img')({
  blockSize: 'auto',
  maxBlockSize: 355,
  inlineSize: '100%',
  position: 'absolute',
  insetBlockEnd: 0,
  zIndex: -1
})

const NotFound = ({ mode }: { mode: SystemMode }) => {
  // Vars
  const darkImg = '/images/pages/misc-mask-dark.png'
  const lightImg = '/images/pages/misc-mask-light.png'

  // Hooks
  const theme = useTheme()
  const hidden = useMediaQuery(theme.breakpoints.down('md'))
  const miscBackground = useImageVariant(mode, lightImg, darkImg)
  const { t } = useTranslation()

  return (
    <div className='flex items-center justify-center min-bs-[100dvh] relative p-6 overflow-x-hidden'>
      <div className='flex items-center flex-col text-center gap-8'>
        <i className='tabler-map-question text-[80px] text-textDisabled' />
        <div className='flex flex-col gap-2 is-[90vw] sm:is-[unset]'>
          <Typography className='font-medium text-8xl' color='text.primary'>
            404
          </Typography>
          <Typography variant='h4'>{t('notFound.title')}</Typography>
          <Typography color='text.secondary'>{brandify(t('notFound.body'))}</Typography>
        </div>
        {/* Stessa icona della voce Home in navbar (menuData). */}
        <Button href='/home' component={Link} variant='contained' startIcon={<i className='akar-icons-dashboard' />}>
          {t('notFound.backHome')}
        </Button>
      </div>
      {!hidden && (
        <MaskImg
          alt='mask'
          src={miscBackground}
          className={classnames({ 'scale-x-[-1]': theme.direction === 'rtl' })}
        />
      )}
    </div>
  )
}

export default NotFound
